import { useEffect, useRef, useState } from 'react';

export default function MouthpieceFaq() {
  const sectionRef = useRef<HTMLElement>(null);
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.fade-up, .fade-up-item').forEach((el) => {
              el.classList.add('visible');
            });
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const faqs = [
    {
      question: 'Q1:初回相談や診査に費用はかかりますか?',
      answer: 'いいえ、初回相談・診査・レポート作成・ご説明まですべて無料です。費用が発生するのは治療を希望され契約する場合のみです。',
    },
    {
      question: 'Q2:その場で決断する必要はありますか?',
      answer: 'いいえ、その場で決める必要はありません。レポートをお持ち帰りいただき、ご家族とご相談したり、他院と比較したりしてからのご決定で大丈夫です。',
    },
    {
      question: 'Q3:他の医院と比較してから決めても大丈夫ですか?',
      answer: 'はい、もちろん大丈夫です。当院のレポートは比較しやすい形式で作成しており、他院との比較にもご活用いただけます。',
    },
  ];

  return (
    <section ref={sectionRef} className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2
          className="text-3xl md:text-4xl font-normal text-center text-gray-900 mb-12 fade-up font-serif"
        >
          よくあるご質問
        </h2>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-gray-200 rounded-lg overflow-hidden fade-up-item"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <span className="font-semibold text-gray-900 pr-4">{faq.question}</span>
                <i
                  className={`ri-add-line text-gray-600 flex-shrink-0 text-xl transition-transform duration-300 ${
                    openIndex === index ? 'rotate-45' : ''
                  }`}
                />
              </button>
              <div
                className={`overflow-hidden ${
                  openIndex === index ? 'opacity-100' : 'max-h-0 opacity-0'
                }`}
                style={{
                  maxHeight: openIndex === index ? '500px' : '0',
                  transition: 'max-height 0.4s ease, opacity 0.3s ease',
                }}
              >
                <div className="px-6 pb-6">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}